/**
 * Dashboard constants and configuration.
 */

/** Y-axis configuration for charts */
export const Y_AXIS = {
  /** Headroom multiplier above max value */
  HEADROOM_MULTIPLIER: 1.15,
  /** Threshold for zooming in on small variations (as fraction of max) */
  ZOOM_THRESHOLD: 0.3,
  /** Padding multiplier for zoomed y-axis */
  ZOOM_PADDING_MULTIPLIER: 0.2,
  /** Minimum padding as fraction of max */
  MIN_PADDING_MULTIPLIER: 0.1,
} as const;

/** Chart height configuration */
export const CHART_HEIGHT = {
  /** Height for mini sparklines in stat cards */
  MINI_SPARKLINE: 40,
  /** Height for metric card sparklines */
  METRIC_SPARKLINE: 48,
  /** Height for main trend charts */
  TREND_CHART: 280,
} as const;
